// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import '../PagePartner.css';

import Breadcrumb from 'components/fragments/Breadcrumb';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import SideBillboardCard from 'components/billboard/SideBillboardCard';
import Sidebar from 'components/sidebar/Sidebar';
import BackgroundImage from 'containers/fragments/BackgroundImageContainer';
import LiveScore from 'containers/fragments/LiveScoreContainer';

import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';
import type { CategoryArticleType, ArticleType } from 'types/Article';

export type StateProps = {
  categoriesArticle: CategoryArticleType[],
};

type Props = {
  title: string,
  featured_media: {
    src: string,
    legend: string,
  },
  excerpt: string,
  meta_description: string,
  status: Status,
  description: BlocContent[],
  sidebar: BlocContent[],
  banniere: string,
  match: {
    params: {
      slug: string,
    }
  },
  pageSlug: string,
  rencontresLive: number,
  organization: string
} & StateProps;

type State = {
  partnersNews: ArticleType[],
};

class PagePartners extends Component<Props, State> {
  state = {
    partnersNews : [],
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    const { categoriesArticle } = props;
    const { partnersNews } = state;

    if (categoriesArticle.length > 0 && !partnersNews.length) {
      const partnersNews = categoriesArticle.reduce((acc, { slug, items }) => {
        if (slug === 'partenaires') {
          const firstThreeNews = items.slice(0, 3);
          acc.push(...firstThreeNews);
        };

        return acc;
      }, []);
      return { partnersNews };
    }
    return null;
  }

  renderBlocContent = () => {
  const { description } = this.props;
    return description.map<any>((blocProps, index) => {
      return (
        <ContentBloc key={index} {...blocProps} />
      );
    });
  };

  renderPartnerNews = (): React$Element<'div'>[] | null => {
    const { partnersNews } = this.state;
    if (partnersNews.length) {
      return partnersNews.map((news: ArticleType): React$Element<'div'> => (
        <div key={`actu-partenaire-${news.slug}`} className="col col-md-6 col-lg-4">
          <SideBillboardCard content={news} />
        </div>
      ));
    }
    return null;
  };

  render() {
    const { renderPartnerNews, renderBlocContent } = this;
    const {
      featured_media,
      title,
      excerpt,
      sidebar,
      banniere,
      rencontresLive,
      organization,
    } = this.props;
    const { partnersNews } = this.state;

    let bannerClass = "banner";
    if (rencontresLive) {
      bannerClass = "banner banner--live-score";
    }

    return (
      <>
        <section className={bannerClass}>
          <BackgroundImage
            className="banner__thumbnail img-blue-dark"
            illustration={featured_media.src || banniere}
            baliseImg={false}
          />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title} {organization ?? ''}</h1>
            {excerpt &&
            <p className="banner__desc">
              {excerpt}
            </p>}
          </div>
          <LiveScore />
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <div className="col col-lg-8on9">
                <div className="page mt-2 mt-md-0">
                  {(partnersNews.length > 0) && (
                    <div className="page__article">
                      <h2 className="ft-h3 mb-4 mt-md-0 is-inline">Actualités des partenaires</h2>
                      <Link
                        to='/actualites'
                        className="link-chevron link-chevron--right">
                          <span>Voir toutes les actualités</span>
                          <i className="icon icon-chevron-right" />
                      </Link>
                      <div className="row mb-7">
                        {renderPartnerNews()}
                      </div>
                    </div>
                  )}
                {renderBlocContent()}
                </div>
              </div>
            </div>
            <Sidebar sidebarContent={sidebar} />
          </div>
        </div>
      </>
    );
  }
}

export default PagePartners;
